import React, { useEffect } from "react";
import { Categories } from "./categories";
import { SearchResultsSection } from "./results";
import CloseIcon from "@mui/icons-material/Close";

import { BeachSection } from "./sections/beach";
import { CitySection } from "./sections/city";
import { EssentialsSection } from "./sections/essentials";
import { NatureSection } from "./sections/nature";
import { OtherSection } from "./sections/other";
import { PricesSection } from "./sections/prices";
import { WeatherSection } from "./sections/weather";
import { Button, Icon, IconButton, SvgIcon } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { icons } from "./utils/icons";
import { ClearFormButton } from "./components/clear-form-button";

type SearchFormDesktopProps = {
    className?: string;
    closable?: boolean;
    category?: string;
    onClose?: () => void;
};

export const SearchFormDesktop = ({
    className,

    category,
    closable,
    onClose
}: SearchFormDesktopProps) => {
    const [currentCategory, setCurrentCategory] = React.useState(
        category || "essentials"
    );
    const scrollRef = React.useRef(null);
    useEffect(() => {
        // scrollRef.current && scrollRef.current.scrollTo(0, 0);
    }, [currentCategory]);
    const form = useFormContext();
    const clearForm = () => {
        form.reset();
    };

    return (
        <div
            className={`shadow-standard relative mx-auto w-[90vw] max-w-[1400px] bg-white lg:rounded-lg lgmax:rounded-lg ${className}`}
        >
            <div className="flex h-[482px] items-start justify-start ">
                <div className="flex h-full w-[300px] flex-col border-r-2 border-solid border-gray-100 p-4 pb-6">
                    <Categories
                        activeCategory={currentCategory}
                        onCategoryClick={(cat) => setCurrentCategory(cat)}
                        className="flex-1"
                    />
                    <ClearFormButton onClick={clearForm} />
                </div>
                <div className="relative h-full flex-1 overflow-y-hidden py-3">
                    <div
                        ref={scrollRef}
                        className="custom-scrollbar h-full overflow-y-auto overflow-x-hidden px-8 pt-4 scrollbar-track-gray-200 scrollbar-thumb-sh-red scrollbar-track-rounded-md scrollbar-thumb-rounded-md scrollbar-w-[8px]"
                    >
                        {currentCategory === "essentials" && (
                            <EssentialsSection />
                        )}
                        {currentCategory === "weather" && <WeatherSection />}
                        {currentCategory === "beach" && <BeachSection />}
                        {currentCategory === "nature" && <NatureSection />}
                        {currentCategory === "city" && <CitySection />}
                        {currentCategory === "prices" && <PricesSection />}
                        {currentCategory === "other" && <OtherSection />}
                        <div className="h-[22px]"></div>
                    </div>

                    <div className="scrollbar-fade-overlay"></div>
                </div>
                <div className="h-full w-[280px] flex-grow-0 px-8 lg:w-[380px]">
                    <SearchResultsSection />
                </div>
                {closable && (
                    <IconButton
                        color="shBlack"
                        onClick={() => onClose && onClose()}
                        aria-label="close"
                        className="absolute top-[8px] right-[8px]"
                    >
                        <CloseIcon />
                    </IconButton>
                )}
            </div>
        </div>
    );
};
function useFormProvider() {
    throw new Error("Function not implemented.");
}
